import { createRootRouteWithContext, Link, Outlet } from '@tanstack/react-router';
import { TanStackRouterDevtools } from '@tanstack/react-router-devtools';
import { useTranslation } from 'react-i18next';

import { EmptyState } from '@nucleus-commerce/admin-kit/layout';
import { Button } from '@nucleus-commerce/ui/components/button';

import { devtoolsEnabled } from '@/app/devtools';
import type { RouterContext } from '@/app/router';

function NotFound() {
  const { t } = useTranslation('common');
  return (
    <div className="flex min-h-svh items-center justify-center p-6">
      <EmptyState
        title={t('notFound.title')}
        description={t('notFound.description')}
        action={
          <Button asChild>
            <Link to="/">{t('notFound.home')}</Link>
          </Button>
        }
      />
    </div>
  );
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => (
    <>
      <Outlet />
      {devtoolsEnabled ? (
        <TanStackRouterDevtools
          position="bottom-right"
          // Sits next to the Query devtools toggle, which owns the corner; both clear the sidebar footer.
          toggleButtonProps={{ style: { right: '4.75rem', bottom: '0.75rem' } }}
        />
      ) : null}
    </>
  ),
  notFoundComponent: NotFound,
});
